import React from 'react';
import { Select } from '@mantine/core';
import { BaseFieldProps } from './types';
import { BooleanMetadata, SelectMetadata } from 'src/data-capture/types';

export function SelectField<T extends Record<string, unknown>>({
  fieldLabel,
  entityMetadata,
  disabled,
  rightValue,
  form,
  formFieldName,
  variant,
  fieldName,
  onChange,
}: BaseFieldProps<T>) {
  if (entityMetadata.type !== 'SELECT' && entityMetadata.type !== 'BOOLEAN') {
    return null;
  }

  const options = generateOptionsFromMetadata(entityMetadata);
  const inputProps = form.getInputProps(formFieldName);

  return (
    <Select
      id={formFieldName}
      label={fieldLabel}
      labelProps={{ variant: 'light' }}
      required={!entityMetadata.isOptional}
      data={options}
      searchable={options.length > 10}
      disabled={disabled}
      rightSection={rightValue}
      clearable
      key={form.key(formFieldName)}
      {...inputProps}
      variant={variant}
      onChange={value => onChange(value, fieldName)}
    />
  );
}

const generateOptionsFromMetadata = (metadata: SelectMetadata | BooleanMetadata) => {
  return [
    ...metadata.options
      .map(option => ({
        value: option.value.toString(),
        label: option.label.toString(),
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];
};
